import InstallPWA from '../ui/InstallPWA';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-slate-200 mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-6">
        {/* Install PWA button - centered above copyright */}
        <div className="flex justify-center mb-4">
          <InstallPWA />
        </div>

        {/* Copyright - centered with middle dots */}
        <p className="text-sm text-slate-600 text-center">
          © 2026 · PropertyCheck.PRO · Wszelkie prawa zastrzeżone
        </p>
      </div>
    </footer>
  );
}
